export const REVIEWS_TAB_TITLE = 'Reviews'
export const OVERVIEW_TAB = 0
export const REVIEWS_TAB = 2
